module.exports = __webpack_public_path__ + "static/img/oportunidad-highred.06d4504.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oportunidad-highred.jpg
// module id = pSxX
// module chunks = 1